import {ELEMENT} from '../base/ElementTypes';
import {IElementQuestionAnswer, IElementQuestionnaire} from '../base/questionElementBase';

export enum SequenceQuestionMode {
    DRAG = 'drag',
    CLICK = 'click',
}

export interface IElementSequenceQuestion extends IElementQuestionnaire {
    type: ELEMENT.SEQUENCE_QUESTION;
    sequence: IElementQuestionAnswer[];
    correctSequence: string[];
    isDebatable?: boolean;
    automaticShuffle?: boolean;
    sequenceMode?: SequenceQuestionMode;
    htmlSlotId?: string;
}
